import SketchComponent from './SketchComponentHost';
export default  SketchComponent;
